import { render, staticRenderFns } from "./ContactOpportunities.vue?vue&type=template&id=7f71f920&scoped=true"
import script from "./ContactOpportunities.vue?vue&type=script&lang=js"
export * from "./ContactOpportunities.vue?vue&type=script&lang=js"
import style0 from "./ContactOpportunities.vue?vue&type=style&index=0&id=7f71f920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f71f920",
  null
  
)

export default component.exports